/**
 * Resolves the in-app quote detail path for the current user's roles.
 * Priority matches home redirect: ADMIN → OPERATIONS → SALES → GM → CLIENT.
 */
export function getQuoteDetailPathForRoles(quoteId: string, roles: string[]): string | null {
  const hasRole = (role: string) =>
    roles.some((userRole) => userRole.toLowerCase() === role.toLowerCase());

  if (hasRole('ADMIN')) {
    return `/admin/quotes/${quoteId}`;
  }
  if (hasRole('OPERATIONS')) {
    return `/operations/quotes/${quoteId}`;
  }
  if (hasRole('SALES')) {
    return `/sales/quotes/${quoteId}`;
  }
  if (hasRole('GM')) {
    return `/gm/quotes/${quoteId}`;
  }
  if (hasRole('CLIENT')) {
    return `/client/quotes/${quoteId}`;
  }
  return null;
}
